import useAxios from "axios-hooks";
import { useParams } from "react-router-dom";
import AssignmentStudents from "./AssignmentStudents";
import { calculateTimeProgress, timeProgress } from "../../util/helpers";

export default function AssigmentStats() {
  const params = useParams();
  const [
    {
      data: assigmentStats,
      loading: assigmentStatsLoading,
      error: assigmentStatsError,
    },
    getAssignmentStats,
  ] = useAxios({
    url: `/assignments/${params.assignmentId}/stats`,
  });

  const assigmentProgressPercentage = calculateTimeProgress(
    assigmentStats?.startDate,
    assigmentStats?.endDate
  );

  const assigmentProgress = timeProgress(
    assigmentStats?.startDate,
    assigmentStats?.endDate
  );

  return (
    <div>
      {!assigmentStatsLoading && Object?.keys(assigmentStats).length !== 0 && (
        <>
          <div className="p-2 border dark:border-white/10 rounded-lg mb-6 mt-2 font-bold ">
            {assigmentProgress?.label}
          </div>
          <div className="text-lg font-bold pb-2 ">Stats</div>
          <div className="stats 2xl:stats-horizontal stats-vertical 2xl:w-full md:w-[30%] w-full border dark:border-white dark:border-opacity-5 shadow-xl mb-10">
            <StatBadge
              title={"Total Students"}
              loading={assigmentStatsLoading}
              value={assigmentStats?.totalUsers}
              description={"Number of students enrolled in this assignment"}
            ></StatBadge>
            <StatBadge
              title={"Total Courses"}
              loading={assigmentStatsLoading}
              value={assigmentStats?.joinedCourses?.length}
              description={
                "Count of distinct courses linked to this assignment"
              }
            ></StatBadge>
            <StatBadge
              title={"Total Labs"}
              loading={assigmentStatsLoading}
              value={assigmentStats?.joinedLabs?.length}
              description={"Number of labs included as part of this assignment"}
            ></StatBadge>
            <StatBadge
              title={"Finished Students Count"}
              loading={assigmentStatsLoading}
              value={`${assigmentStats?.usersFinishedAllCount}/${assigmentStats?.totalUsers}`}
              description={
                "Students who have completed all tasks out of total enrolled"
              }
            ></StatBadge>

          </div>
        </>
      )}

      <div className="text-lg font-bold pb-2 ">Students</div>
      <AssignmentStudents></AssignmentStudents>
    </div>
  );
}

function StatBadge(props: {
  title: string;
  value: string;
  description?: any;
  icon?: any;
  loading?: boolean;
}) {
  return (
    <div className="bg-base-200 shadow-xl !border-0">
      <div className="stat 2xl:w-[16rem] w-[100%] ">
        <div className="stat-title sm:text-sm text-xs capitalize">
          {props.title}
        </div>
        {props.loading ? (
          <div className="stat-value h-10 flex items-center">
            <span className="h-7 loading loading-spinner"></span>
          </div>
        ) : (
          <div className="stat-value md:text-4xl text-lg">{props.value}</div>
        )}
        <div className="stat-desc text-xs whitespace-pre-wrap">
          {props.description}
        </div>
      </div>
    </div>
  );
}
